import React from 'react';

const Terms = () => {
  return (
    <div style={{ padding: '50px', marginTop: '50px', maxWidth: '900px', lineHeight: 1.7 }}>
      <h1>Terms of Service</h1>
      <p>Last updated: Jul 9, 2026</p>

      <h2>Acceptance of Terms</h2>
      <p>
        By accessing or using Hashely, you agree to these Terms of Service. If you do not agree,
        do not use the service.
      </p>

      <h2>Accounts</h2>
      <p>
        You are responsible for maintaining the security of your account and for all activity that
        occurs under your account.
      </p>

      <h2>Acceptable Use</h2>
      <p>
        You agree not to misuse the service, including attempting unauthorized access, violating
        laws, or posting harmful content.
      </p>

      <h2>Subscriptions and Billing</h2>
      <p>
        Paid plans are billed according to the selected billing cycle. Pricing and plan details are
        shown on the pricing page and may be updated from time to time.
      </p>

      <h2>Changes to Service</h2>
      <p>
        We may modify or discontinue parts of the service at any time, with or without notice.
      </p>

      <h2>Contact</h2>
      <p>For questions about these terms, contact: memeek01@gmail.com</p>
    </div>
  );
};

export default Terms;
